// 官网前端主逻辑 - 调用后端API
const API_BASE_URL = 'http://localhost:8080/api';

// 全局变量
let currentCompany = null;
let currentProducts = [];
let currentView = 'home';

// 初始化应用
function initializeApp() {
    // 获取URL参数
    const urlParams = getUrlParams();
    
    // 根据URL参数决定显示哪个页面
    if (urlParams.page === 'products') {
        showProductList();
    } else if (urlParams.page === 'product' && urlParams.product) {
        showProductDetail(urlParams.product);
    } else {
        // 默认显示首页
        showMainContent();
        // 加载公司信息
        loadCompanyInfo(urlParams.ou || '1');
        // 加载热门产品
        loadFeaturedProducts();
    }
    
    // 初始化路由
    initializeRouting();
}

// 获取URL参数
function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        ou: params.get('ou'),
        page: params.get('page'),
        product: params.get('product')
    };
}

// 更新URL参数
function updateUrl(params) {
    const url = new URL(window.location);
    Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
            url.searchParams.set(key, params[key]);
        } else {
            url.searchParams.delete(key);
        }
    });
    history.pushState({}, '', url);
}

// 加载公司信息
async function loadCompanyInfo(orgUnit) {
    try {
        const response = await fetch(`${API_BASE_URL}/company/info?ouCode=${orgUnit}`);
        const result = await response.json();

        if (result.code === 200 && result.data) {
            currentCompany = result.data;
            updateCompanyInfo(result.data);
        } else {
            console.error('加载公司信息失败:', result.message);
            showError('加载公司信息失败，请稍后重试');
        }
    } catch (error) {
        console.error('加载公司信息出错:', error);
        showError('网络连接失败，请检查网络连接');
    }
}

// 更新公司信息到页面
function updateCompanyInfo(company) {
    // 更新公司名称
    const companyName = document.getElementById('company-name');
    if (companyName) {
        companyName.textContent = company.name;
    }
    
    const footerCompanyName = document.getElementById('footer-company-name');
    if (footerCompanyName) {
        footerCompanyName.textContent = company.name;
    }
    
    // 更新首页标题和描述
    const heroTitle = document.querySelector('.hero-content h1');
    if (heroTitle) {
        heroTitle.textContent = company.heroTitle || company.name;
    }
    
    const heroDescription = document.querySelector('.hero-content p');
    if (heroDescription) {
        heroDescription.textContent = company.heroDescription || company.description;
    }
    
    // 更新公司描述
    const companyDesc = document.querySelector('.company-description');
    if (companyDesc) {
        companyDesc.textContent = company.description;
    }
    
    // 更新公司统计信息
    const foundedYear = document.getElementById('company-founded');
    if (foundedYear) {
        foundedYear.textContent = company.founded || '2020';
    }
    
    const employeeCount = document.getElementById('company-employees');
    if (employeeCount) {
        employeeCount.textContent = company.employees || '100+';
    }
    
    const productCount = document.getElementById('company-products');
    if (productCount) {
        // 优先使用API的产品数量，如果没有则获取实时数量
        if (company.productsCount) {
            productCount.textContent = company.productsCount;
        } else {
            loadProductCount();
        }
    }
    
    // 更新公司简介
    const companyIntro = document.getElementById('company-intro');
    if (companyIntro) {
        companyIntro.textContent = company.description || '我们是一家专注于创新技术的企业，致力于为客户提供高质量的产品和服务。';
    }
    
    // 更新联系信息
    const companyAddress = document.querySelector('.company-address');
    if (companyAddress) {
        companyAddress.textContent = company.address;
    }
    
    const companyPhone = document.querySelector('.company-phone');
    if (companyPhone) {
        companyPhone.textContent = company.phone;
    }
    
    const companyEmail = document.querySelector('.company-email');
    if (companyEmail) {
        companyEmail.textContent = company.email;
    }
}

// 加载产品数量统计
async function loadProductCount() {
    try {
        const response = await fetch(`${API_BASE_URL}/product/count`);
        if (response.ok) {
            const result = await response.json();
            if (result.code === 200) {
                const productCountElement = document.getElementById('company-products');
                if (productCountElement) {
                    productCountElement.textContent = result.data + '+';
                }
            }
        }
    } catch (error) {
        console.log('获取产品数量失败，使用默认值');
    }
}

// 显示产品列表页面
function showProductList() {
    updateUrl({ page: 'products', product: null });
    hideMainContent();
    createProductListPage();
    currentView = 'products';
    
    // 确保DOM元素已经渲染后再加载数据
    setTimeout(() => {
        loadProductList();
    }, 100);
}

// 创建产品列表页面
function createProductListPage() {
    // 清除已有的产品列表页面
    const existingPage = document.querySelector('.product-list-page');
    if (existingPage) {
        existingPage.remove();
    }
    
    // 插入到main元素中，而不是container
    const main = document.querySelector('main');
    
    // 创建产品列表页面HTML
    const productListHTML = `
        <div class="product-list-page">
            <div class="container">
                <div class="breadcrumb">
                    <a href="javascript:void(0)" onclick="goHome()">首页</a> > 产品中心
                </div>
                
                <div class="product-search-section">
                    <h2>产品中心</h2>
                    <p>发现我们精心打造的优质应用产品</p>
                    
                    <div class="search-controls">
                        <div class="search-box">
                            <i class="search-icon">🔍</i>
                            <input type="text" id="search-input" placeholder="搜索产品名称或描述..." oninput="filterProducts()">
                        </div>
                        
                        <div class="category-filter">
                            <button class="filter-btn active" onclick="filterByCategory('')">全部</button>
                            <button class="filter-btn" onclick="filterByCategory('办公效率')">办公效率</button>
                            <button class="filter-btn" onclick="filterByCategory('购物生活')">购物生活</button>
                            <button class="filter-btn" onclick="filterByCategory('健康医疗')">健康医疗</button>
                            <button class="filter-btn" onclick="filterByCategory('教育学习')">教育学习</button>
                            <button class="filter-btn" onclick="filterByCategory('金融理财')">金融理财</button>
                            <button class="filter-btn" onclick="filterByCategory('物流配送')">物流配送</button>
                        </div>
                    </div>
                    
                    <div class="search-results-info">
                        <span id="results-count">正在加载...</span>
                    </div>
                </div>
                
                <div class="products-grid" id="products-grid">
                    <!-- 产品卡片将在这里动态生成 -->
                </div>
            </div>
        </div>
    `;
    
    // 插入到main元素中
    main.insertAdjacentHTML('beforeend', productListHTML);
}

// 加载产品列表
async function loadProductList(category = '', keyword = '') {
    const productsGrid = document.getElementById('products-grid');
    
    if (productsGrid) {
        productsGrid.innerHTML = showLoading('正在加载产品列表...');
    }

    try {
        const params = new URLSearchParams({
            page: 1,
            size: 50
        });

        if (category) {
            params.append('category', category);
        }

        if (keyword) {
            params.append('keyword', keyword);
        }

        const response = await fetch(`${API_BASE_URL}/product/list?${params}`);
        const result = await response.json();

        if (result.code === 200 && result.data) {
            currentProducts = result.data.records || [];
            renderProductList(currentProducts);
            updateSearchResultsInfo(currentProducts.length);
        } else {
            console.error('加载产品列表失败:', result.message);
            // API失败时显示默认产品数据
            renderFallbackProductList(category, keyword);
        }
    } catch (error) {
        console.error('加载产品列表出错:', error);
        // 网络错误时显示默认产品数据
        renderFallbackProductList(category, keyword);
    }
}

// 显示默认的产品列表数据
function renderFallbackProductList(category = '', keyword = '') {
    const fallbackProducts = [
        {
            id: 1,
            name: '智办公Pro',
            description: '企业级办公协作APP，集成任务管理、团队沟通、文档协作等核心功能，助力企业高效办公。',
            category: '办公效率',
            iconUrl: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=512&h=512&fit=crop',
            rating: 4.8,
            downloads: '10万+'
        },
        {
            id: 2,
            name: '购物达人',
            description: '购物助手APP，提供个性化推荐、优惠比价、社区分享等功能，让购物更智能。',
            category: '购物生活',
            iconUrl: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=512&h=512&fit=crop',
            rating: 4.6,
            downloads: '25万+'
        },
        {
            id: 3,
            name: '健康生活家',
            description: '健康管理APP，提供运动记录、饮食分析、健康监测等全方位健康服务。',
            category: '健康医疗',
            iconUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=512&h=512&fit=crop',
            rating: 4.7,
            downloads: '15万+'
        },
        {
            id: 4,
            name: '学习通',
            description: '在线学习平台APP，支持直播课程、互动学习、作业管理等功能。',
            category: '教育学习',
            iconUrl: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=512&h=512&fit=crop',
            rating: 4.9,
            downloads: '50万+'
        },
        {
            id: 5,
            name: '理财小助手',
            description: '个人理财管理APP，提供智能记账、投资分析、理财规划等服务。',
            category: '金融理财',
            iconUrl: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=512&h=512&fit=crop',
            rating: 4.5,
            downloads: '8万+'
        },
        {
            id: 6,
            name: '快递管家',
            description: '智能物流管理APP，为物流企业和个人用户提供订单跟踪、路线规划等服务。',
            category: '物流配送',
            iconUrl: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=512&h=512&fit=crop',
            rating: 4.4,
            downloads: '12万+'
        }
    ];

    // 根据分类和关键词筛选产品
    let filteredProducts = fallbackProducts;

    if (category && category !== '全部') {
        filteredProducts = filteredProducts.filter(product => product.category === category);
    }

    if (keyword) {
        filteredProducts = filteredProducts.filter(product =>
            product.name.toLowerCase().includes(keyword.toLowerCase()) ||
            product.description.toLowerCase().includes(keyword.toLowerCase())
        );
    }

    currentProducts = filteredProducts;
    renderProductList(filteredProducts);
    updateSearchResultsInfo(filteredProducts.length);

    // 显示提示信息（非错误，只是提醒）
    showInfo('当前显示的是演示数据，请启动后端服务以查看完整数据');
}

// 渲染产品列表
function renderProductList(products) {
    const productsGrid = document.getElementById('products-grid');
    
    if (!productsGrid) {
        console.error('未找到products-grid元素');
        return;
    }
    
    productsGrid.innerHTML = '';
    
    if (products.length === 0) {
        productsGrid.innerHTML = '<div class="no-products">暂无产品</div>';
        return;
    }
    
    products.forEach(product => {
        const productCard = createProductCard(product);
        productsGrid.appendChild(productCard);
    });
}

// 创建产品卡片
function createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'product-card';
    
    card.innerHTML = `
        <div class="product-content">
            <div class="product-header">
                <div class="product-icon">
                    <img src="${product.iconUrl}" alt="${product.name}" onerror="this.src='https://via.placeholder.com/80x80?text=${encodeURIComponent(product.name)}'">
                </div>
                <div class="product-title-info">
                    <h3>${product.name}</h3>
                    <span class="product-category">${product.category}</span>
                </div>
            </div>
            <p class="product-description">${product.description}</p>
            <div class="product-meta">
                <span class="rating">⭐ ${product.rating}</span>
                <span class="downloads">${formatDownloads(product.downloads)}</span>
            </div>
            <div class="product-actions">
                <button class="btn btn-primary" onclick="viewProductDetail(${product.id})">查看详情</button>
            </div>
        </div>
    `;
    
    return card;
}

// 查看产品详情
function viewProductDetail(productId) {
    updateUrl({ page: 'product', product: productId });
    showProductDetail(productId);
}

// 显示产品详情页面
async function showProductDetail(productId) {
    hideMainContent();
    
    // 显示加载状态
    const main = document.querySelector('main');
    main.insertAdjacentHTML('beforeend', `
        <div class="product-detail">
            <div class="container">
                ${showLoading('正在加载产品详情...')}
            </div>
        </div>
    `);
    
    try {
        const response = await fetch(`${API_BASE_URL}/product/${productId}`);
        const result = await response.json();
        
        if (result.code === 200 && result.data) {
            // 移除加载状态
            document.querySelector('.product-detail').remove();
            createProductDetailPage(result.data);
        } else {
            console.error('加载产品详情失败:', result.message);
            document.querySelector('.product-detail').innerHTML = `
                <div class="container">
                    <div class="error-message">加载产品详情失败：${result.message}</div>
                    <div class="text-center">
                        <button class="btn btn-secondary" onclick="goBack()">返回产品列表</button>
                    </div>
                </div>
            `;
        }
    } catch (error) {
        console.error('加载产品详情出错:', error);
        document.querySelector('.product-detail').innerHTML = `
            <div class="container">
                <div class="error-message">网络连接失败，无法加载产品详情</div>
                <div class="text-center">
                    <button class="btn btn-secondary" onclick="goBack()">返回产品列表</button>
                </div>
            </div>
        `;
    }
}

// 创建产品详情页面
function createProductDetailPage(product) {
    const main = document.querySelector('main');
    
    const productDetailHTML = `
        <div class="product-detail">
            <div class="container">
                <div class="breadcrumb">
                    <a href="javascript:void(0)" onclick="goHome()">首页</a> > 
                    <a href="javascript:void(0)" onclick="goBack()">产品中心</a> > 
                    ${product.name}
                </div>
            
                <div class="product-detail-content">
                    <!-- 产品基本信息 -->
                    <div class="product-basic-info">
                        <div class="product-logo">
                            <img src="${product.iconUrl}" alt="${product.name}" onerror="this.src='https://via.placeholder.com/512x512?text=${encodeURIComponent(product.name)}'">
                        </div>
                        <div class="product-main-info">
                            <h1>${product.name}</h1>
                            <p class="product-intro">${product.description}</p>
                        </div>
                    </div>
                    
                    <!-- 应用截图 -->
                    ${product.screenshots && product.screenshots.length > 0 ? `
                        <div class="product-screenshots">
                            <h3>应用截图</h3>
                            <div class="screenshots-container">
                                ${product.screenshots.map(screenshot => `
                                    <div class="screenshot-item">
                                        <img src="${screenshot}" alt="应用截图" onerror="this.src='https://via.placeholder.com/1080x1920?text=Screenshot'">
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                    ` : ''}
                </div>
            </div>
        </div>
    `;
    
    main.insertAdjacentHTML('beforeend', productDetailHTML);
}

// 隐藏主内容
function hideMainContent() {
    const mainSections = document.querySelectorAll('#home, #about, #products, #contact');
    mainSections.forEach(section => {
        section.style.display = 'none';
    });
    
    // 移除动态创建的页面
    const dynamicPages = document.querySelectorAll('.product-list-page, .product-detail');
    dynamicPages.forEach(page => {
        page.remove();
    });
}

// 显示主内容
function showMainContent() {
    // 移除动态页面
    const dynamicPages = document.querySelectorAll('.product-list-page, .product-detail');
    dynamicPages.forEach(page => {
        page.remove();
    });
    
    // 显示主要页面内容
    const mainSections = document.querySelectorAll('#home, #about, #products, #contact');
    mainSections.forEach(section => {
        section.style.display = 'block';
    });
    
    // 设置当前视图
    currentView = 'home';
    
    // 加载热门产品
    loadFeaturedProducts();
}

// 加载热门产品
async function loadFeaturedProducts() {
    const featuredGrid = document.getElementById('featured-products-grid');
    if (!featuredGrid) return;

    // 显示加载状态
    featuredGrid.innerHTML = showLoading('正在加载热门产品...');

    try {
        const response = await fetch(`${API_BASE_URL}/product/featured?limit=3`);
        const result = await response.json();

        if (result.code === 200 && result.data && result.data.length > 0) {
            renderFeaturedProducts(result.data);
        } else {
            console.error('加载热门产品失败:', result.message);
            // 显示默认的静态产品数据
            renderFallbackFeaturedProducts();
        }
    } catch (error) {
        console.error('加载热门产品出错:', error);
        // 显示默认的静态产品数据
        renderFallbackFeaturedProducts();
    }
}

// 显示默认的热门产品（当API不可用时）
function renderFallbackFeaturedProducts() {
    const fallbackProducts = [
        {
            id: 1,
            name: '智办公Pro',
            description: '企业级办公协作APP，集成任务管理、团队沟通、文档协作等核心功能',
            category: '办公效率',
            iconUrl: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=512&h=512&fit=crop',
            rating: 4.8,
            downloads: '10万+'
        },
        {
            id: 2,
            name: '购物达人',
            description: '购物助手APP，提供个性化推荐、优惠比价、社区分享等功能',
            category: '购物生活',
            iconUrl: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=512&h=512&fit=crop',
            rating: 4.6,
            downloads: '25万+'
        },
        {
            id: 3,
            name: '健康生活家',
            description: '健康管理APP，提供运动记录、饮食分析、健康监测等全方位服务',
            category: '健康医疗',
            iconUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=512&h=512&fit=crop',
            rating: 4.7,
            downloads: '15万+'
        }
    ];

    renderFeaturedProducts(fallbackProducts);
}

// 渲染热门产品
function renderFeaturedProducts(products) {
    const featuredGrid = document.getElementById('featured-products-grid');
    if (!featuredGrid) return;
    
    featuredGrid.innerHTML = '';
    
    products.forEach(product => {
        const productCard = createFeaturedProductCard(product);
        featuredGrid.appendChild(productCard);
    });
}

// 创建热门产品卡片
function createFeaturedProductCard(product) {
    const card = document.createElement('div');
    card.className = 'featured-product-card';
    
    card.innerHTML = `
        <div class="product-content">
            <div class="product-header">
                <div class="product-icon">
                    <img src="${product.iconUrl}" alt="${product.name}" onerror="this.src='https://via.placeholder.com/80x80?text=${encodeURIComponent(product.name)}'">
                </div>
                <div class="product-title-info">
                    <h3>${product.name}</h3>
                    <span class="product-category">${product.category}</span>
                </div>
            </div>
            <p class="product-description">${product.description}</p>
            <div class="product-meta">
                <span class="rating">⭐ ${product.rating}</span>
                <span class="downloads">${formatDownloads(product.downloads)}</span>
            </div>
            <div class="product-actions">
                <button class="btn btn-primary" onclick="viewProductDetail(${product.id})">查看详情</button>
            </div>
        </div>
    `;
    
    return card;
}

// 返回首页
function goHome() {
    // 清除所有URL参数，返回首页
    updateUrl({
        ou: null,
        page: null,
        product: null
    });
    showMainContent();
    currentView = 'home';
    // 重新加载公司信息
    loadCompanyInfo('1');
}

// 返回产品列表
function goBack() {
    updateUrl({ page: 'products', product: null });
    showProductList();
}

// 筛选产品
function filterProducts() {
    const searchInput = document.getElementById('search-input');
    const keyword = searchInput ? searchInput.value.trim() : '';
    
    // 获取当前选中的分类
    const activeCategory = document.querySelector('.filter-btn.active');
    const category = activeCategory ? activeCategory.textContent : '';
    
    // 重新加载产品列表
    loadProductList(category === '全部' ? '' : category, keyword);
}

// 按分类筛选
function filterByCategory(category) {
    // 更新按钮状态
    const filterBtns = document.querySelectorAll('.filter-btn');
    filterBtns.forEach(btn => {
        btn.classList.remove('active');
    });
    
    event.target.classList.add('active');
    
    // 获取搜索关键词
    const searchInput = document.getElementById('search-input');
    const keyword = searchInput ? searchInput.value.trim() : '';
    
    // 重新加载产品列表
    loadProductList(category, keyword);
}

// 更新搜索结果信息
function updateSearchResultsInfo(count) {
    const resultsCount = document.getElementById('results-count');
    if (resultsCount) {
        resultsCount.textContent = `共找到 ${count} 个产品`;
    }
}

// 初始化路由
function initializeRouting() {
    window.addEventListener('popstate', function() {
        const urlParams = getUrlParams();
        
        if (urlParams.page === 'products') {
            showProductList();
        } else if (urlParams.page === 'product' && urlParams.product) {
            showProductDetail(urlParams.product);
        } else {
            showMainContent();
            loadCompanyInfo(urlParams.ou || '1');
        }
    });
}

// 将函数暴露到全局作用域
window.showProductList = showProductList;
window.viewProductDetail = viewProductDetail;
window.goHome = goHome;
window.goBack = goBack;
window.filterProducts = filterProducts;
window.filterByCategory = filterByCategory;

// 显示加载状态
function showLoading(message = '加载中...') {
    const loadingHTML = `
        <div class="loading">
            <div class="loading-spinner"></div>
            <span>${message}</span>
        </div>
    `;
    return loadingHTML;
}

// 显示错误信息
function showError(message) {
    const errorHTML = `<div class="error-message">${message}</div>`;
    const container = document.querySelector('.container');

    // 移除已有的消息
    const existingMessage = container.querySelector('.error-message, .info-message');
    if (existingMessage) {
        existingMessage.remove();
    }

    // 添加新的错误信息
    container.insertAdjacentHTML('afterbegin', errorHTML);

    // 3秒后自动移除错误信息
    setTimeout(() => {
        const errorElement = container.querySelector('.error-message');
        if (errorElement) {
            errorElement.remove();
        }
    }, 3000);
}

// 显示提示信息
function showInfo(message) {
    const infoHTML = `<div class="info-message">${message}</div>`;
    const container = document.querySelector('.container');

    // 移除已有的消息
    const existingMessage = container.querySelector('.error-message, .info-message');
    if (existingMessage) {
        existingMessage.remove();
    }

    // 添加新的提示信息
    container.insertAdjacentHTML('afterbegin', infoHTML);

    // 5秒后自动移除提示信息
    setTimeout(() => {
        const infoElement = container.querySelector('.info-message');
        if (infoElement) {
            infoElement.remove();
        }
    }, 5000);
}

// 隐藏错误信息
function hideError() {
    const errorElement = document.querySelector('.error-message');
    if (errorElement) {
        errorElement.remove();
    }
}

// 格式化下载量显示
function formatDownloads(downloads) {
    if (!downloads) return '0';

    // 如果包含'万'，直接返回
    if (downloads.includes('万') || downloads.includes('亿')) {
        return downloads;
    }

    // 如果是数字，格式化显示
    const num = parseInt(downloads.replace(/[^\d]/g, ''));
    if (num >= 10000) {
        return Math.floor(num / 10000) + '万+';
    }

    return downloads;
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', initializeApp); 